import type { FC } from "react"
import { memo } from "react"

import { ReactNode } from "react"
import "./style.sass"

type Props = {
  step: number
  title: ReactNode
}

const StepComponent: FC<Props> = ({ step, title }) => {
  return (
    <div className="step">
      <div className="step-badge">
        <span className="badge-text">Step {step}</span>
      </div>

      <span className="step-text leading-1">{title}</span>
    </div>
  )
}

export const Step = memo(StepComponent)
